// events emitted to angular used by superclasses of Member
const USER_GROUP_LICENSE_GROUPS_EVENT = {
  UPDATE: {
    COUNT: 'UpdateUserGroupLicenseGroupsCount',
    LIST: 'UpdateUserGroupLicenseGroupsList',
  },
};

export {USER_GROUP_LICENSE_GROUPS_EVENT};
